import alertify from 'alertifyjs';
import('./css/myBulletinPage.scss');
import('alertifyjs/build/css/alertify.min.css');
import('alertifyjs/build/css/themes/default.css');

let url = null;

const names = {
    'diario': 'boletín diario',
    'especiales': 'boletín de especialidades',
    'premium' : 'boletín de usuarios premium',
    'formacion': 'boletín formativo',
    'publi': 'boletín de promociones',
    'profesionales': 'boletín para profesionales',
    'global': 'boletín global',
    'crypto': 'boletín de criptoactivos',
};

const sendAjax = (element) => {
    const option = element.id.substr(5);
    const checked = element.checked;
    const customUrl = `${url}/${option}/${checked.toString()}`;
    fetch(customUrl,{
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(response => response.json())
        .then(response => {
            const newStatus = response.status;
            if (newStatus === 'true') {
                alertify.success(`Se ha suscrito a ${names[option]}`);
            } else {
                alertify.warning(`Se ha desuscrito del ${names[option]}`);
            }
        })
        .catch(error => {
            console.error(error);
            element.checked = !checked;
            alertify.error("No se pudo realizar el cambio del " + names[option] + ". Inténtelo más tarde.")
        })
}

export const myBulletinPage = () => {
    const section = document.querySelector('section.my-newsletter');

    if (!section) {
        //El usuario está accediendo sin estar logado. Abortamos
        return;
    }

    const premium = !!section.dataset.premium;
    url = unmaskpath(section.dataset.url);

    if (section.dataset.bounced) {
        alertify.alert('Email bloqueado<br>No hemos podido enviarle boletines a su correo electrónico. Es posible que la dirección ' +
            'sea erronea o lo haya marcado como SPAM. Póngase en contacto con nosotros para reestablecer el servicio de boletines.', function(){});
        return null;
    }

    document.querySelectorAll('input[type="checkbox"][id^="form_"]').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const option = e.target.id.substr(5);
            const checked = e.target.checked;

            if(!premium && option === 'premium' && checked === true) {
                alertify.error('No puede suscribirse al boletín premium sin ser usuario suscrito');
                e.target.checked = false;
                return false;
            }

            //Va a desuscribirse. Mostrar aviso
            if (checked === false) {
                alertify.confirm(`Realmente deseas darte de baja del ${names[option]}?`, () => {
                    sendAjax(e.target);
                }, () => {
                    e.target.checked = true;
                });
            } else {
                sendAjax(e.target);
            }
        });
    })



}
